import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import AsNumeral from '../../../vendors/asNumeral';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Box, Price, StackInline, TextAlpha } from '@yonderland/andes-react';
import { MiniPDPMultiCTA } from './MiniPDPMultiCTA';
const MiniPDPMultiFooter = ({ numberProducts, totalPrice, currency, handleAddToBasket, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    return (_jsxs(Box, { paddingInline: { lg: '4' }, children: [totalPrice && (_jsx(Box, { paddingBlockEnd: "2", children: _jsxs(StackInline, { itemsAlign: "baseline", gap: "1", children: [_jsxs(TextAlpha, { variant: "bodyS", children: [t('checkout:checkout.basket.total'), ":"] }), _jsx(Price, { currency: currency, priceActual: {
                                formattedPrice: AsNumeral.formatAsCurrency(totalPrice.totalSellPrice),
                            }, pricePrevious: totalPrice.totalSellPrice !== totalPrice.totalStandardPrice
                                ? {
                                    formattedPrice: AsNumeral.formatAsCurrency(totalPrice.totalStandardPrice),
                                }
                                : undefined })] }) })), _jsx(MiniPDPMultiCTA, { amount: numberProducts, handleAddToBasket: handleAddToBasket })] }));
};
export default MiniPDPMultiFooter;
